<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <!--<CIcon name="logo" height="48" alt="Logo"/>-->
    </CHeaderBrand>

    <CMenu/>

    <CHeaderNav class="mr-4" @click.native="logout()">
      
      <CHeaderNavItem class="mx-2 logout" >
       
          <CIcon class='mr-1' name="cil-lock-locked" /> Salir
      
      </CHeaderNavItem>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" text='hola'/>
    </CSubheader>
  </CHeader>
</template>

<script>
import CMenu from './Menu'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    CMenu
  },
  methods: {
    logout(){
      this.$api.auth.logout().then((res) => {
        this.$cookies.remove(this.$apiTokenName);
        this.$router.push({ path: '/login' });
      }).catch((error) => {
        console.log(error);
      });
      //axios.post(this.$apiAdress + '/api/logout?token=' + localStorage.getItem("api_token"),{})
      //.then(function (response) {
      //  localStorage.setItem('roles', '');
      //  self.$router.push({ path: '/login' });
      //}).catch(function (error) {
      //  console.log(error); 
      //});
    }
  }
}
</script>
<style scoped>
.logout{
  cursor: pointer;
}
</style>